export class Search {
    categoryids:number=0;
    totalpage:number=0;
    currentPage:number=0;
    search:string='';
}
